export default __webpack_public_path__ + "School BPIE Assessment.docx";